import React, { useEffect, useMemo, useRef, useState } from 'react';
import {
  RICH_HTML_MESSAGE, RICH_HTML_SANDBOX, buildRichHtmlDocument,
  clampFrameHeight, readThemeTokens,
} from '../lib/richHtmlFrame';

// Yöneticinin yazdığı ham HTML'i yalıtılmış bir çerçevede çizer. Güvenlik ve
// ölçü kuralları lib/richHtmlFrame.js içindedir; bileşen portalda (bonus
// detay penceresi) ve panelde (önizleme) aynı şekilde çalışır.
const RichHtmlFrame = ({
  html, title = 'İçerik', className = '', onHeight,
}) => {
  const frameRef = useRef(null);
  const [height, setHeight] = useState(160);
  // Kartta kırpılmış gösterimde taşma var mı sorusu çerçevenin ölçüsünden
  // yanıtlanır (içerik opak origin'de olduğu için dışarıdan ölçülemez).
  const onHeightRef = useRef(onHeight);
  onHeightRef.current = onHeight;

  const srcDoc = useMemo(() => {
    const body = typeof document !== 'undefined' ? document.body : null;
    const computed = body && typeof window !== 'undefined'
      ? window.getComputedStyle(body)
      : null;
    return buildRichHtmlDocument(html, {
      origin: typeof window !== 'undefined' ? window.location.origin : '',
      fontFamily: computed?.fontFamily || '',
      color: computed?.color || '',
      tokens: readThemeTokens(),
    });
  }, [html]);

  useEffect(() => {
    const onMessage = (event) => {
      // Yalnızca bu çerçevenin kendi bildirimi dinlenir: aynı sayfada ikinci
      // bir çerçeve (ya da yabancı bir betik) yüksekliği değiştirememeli.
      if (!frameRef.current || event.source !== frameRef.current.contentWindow) return;
      if (event.data?.type !== RICH_HTML_MESSAGE) return;
      const next = clampFrameHeight(event.data.height);
      if (next !== null) {
        setHeight(next);
        onHeightRef.current?.(next);
      }
    };
    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, []);

  if (!html || !html.trim()) return null;
  return (
    <iframe
      ref={frameRef}
      title={title}
      sandbox={RICH_HTML_SANDBOX}
      srcDoc={srcDoc}
      className={`block w-full border-0 bg-transparent ${className}`}
      style={{ height }}
    />
  );
};

export default RichHtmlFrame;
